<template xmlns="http://www.w3.org/1999/html">
  <ais-instant-search
    :search-client="searchClient"
    :index-name="algoliaIndexName"
    :routing="routing"
    class="mt-8 mx-4"
  >
    <!-- Search -->
    <ais-search-box class="mb-6">
      <template v-slot="{ refine, currentRefinement }">
        <ApplicationSearchBox
          :refine="refine"
          :default-value="currentRefinement"
        />
      </template>
    </ais-search-box>

    <!-- Filters -->
    <ApplicationFilters class="mb-8" />

    <!-- Result stats -->
    <div class="flex justify-between mb-4">
      <ais-stats
        class="mx-auto inline-block py-1 px-2 text-xs rounded-full bg-slate-300 text-slate-800"
        ><template v-slot="{ nbHits }"
          >Found {{ nbHits }} applications</template
        ></ais-stats
      >
    </div>

    <!-- Loading state -->
    <ais-state-results>
      <template v-slot="{ status }">
        <p v-show="status === 'loading' || status === 'stalled'">
          Loading search results
        </p>
      </template>
    </ais-state-results>

    <!-- Search results -->
    <ais-hits>
      <template v-slot="{ items }">
        <application-list :data="items" />
      </template>
    </ais-hits>

    <!-- Pagination -->
    <ais-pagination>
      <template v-slot="{ currentRefinement, pages, refine, createURL }">
        <div class="text-center pagination pt-7 text-primary-dark">
          <a
            v-for="page in pages"
            :key="page"
            :href="createURL(page)"
            @click.prevent="refine(page)"
            :class="{ selected: page === currentRefinement }"
          >
            {{ page + 1 }}</a
          >
        </div>
      </template>
    </ais-pagination>
  </ais-instant-search>
</template>

<script setup>
import {
  AisInstantSearch,
  AisHits,
  AisPagination,
  AisStateResults,
  AisStats,
  AisSearchBox,
} from "vue-instantsearch/vue3/es";
import { liteClient as algoliaSearch } from "algoliasearch/lite";
import ApplicationList from "@/components/ApplicationList.vue";
import ApplicationFilters from "./ApplicationFilters.vue";
import ApplicationSearchBox from "./ApplicationSearchBox.vue";
import { history as historyRouter } from "instantsearch.js/es/lib/routers";
import { singleIndex as singleIndexMapping } from "instantsearch.js/es/lib/stateMappings";

const props = defineProps({
  algoliaIndexName: {
    type: String,
    required: true,
  },
  algoliaAppId: {
    type: String,
    required: true,
  },
  algoliaApiKey: {
    type: String,
    required: true,
  },
});

const algoliaIndexName = props.algoliaIndexName;
const searchClient = algoliaSearch(props.algoliaAppId, props.algoliaApiKey);
const routing = {
  router: historyRouter(),
  stateMapping: singleIndexMapping(algoliaIndexName),
};
</script>
